import { render, staticRenderFns } from "./code-manager-tier2-comp.vue?vue&type=template&id=40d8e614&"
import script from "./code-manager-tier2-comp.vue?vue&type=script&lang=js&"
export * from "./code-manager-tier2-comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports